import React, { useRef, useState, useEffect } from "react";
import { BellOutline } from "antd-mobile-icons";
import { Tabs, Button } from "antd-mobile-v5";
import { QRCodeCanvas } from "qrcode.react";
import "./reportTip.scss";
import { RouteComponentProps, withRouter } from "react-router-dom";
import iconFile from "../../static/images/icon_file.png"
import { ApiCore } from "../../api";
import backBtn from "../../static/icon/back_button.png";
import utils from "../../utils/utils";
import { Toast } from "antd-mobile";
const api = new ApiCore();

const SubjectBindType = (props: RouteComponentProps<{ subjectCode: string }>) => {
  const { subjectCode } = props.match.params;
  const urlParams = utils.getUrlParams();
  const [bindType, setBindType] = useState<"wx" | "msg">("wx");
  const [codeURL, setCodeURL] = useState<string>("");
  const [bindInfo, setBindInfo] = useState<any>()
  //悬浮按钮项相关
  let oLeft: any;
  let oTop: any;
  let moving: boolean = false;
  let oW: any;
  let oH: any;
  let htmlWidth: any;
  let htmlHeight: any;
  let bWidth: any;
  let bHeight: any;
  let click: boolean = false;
  useEffect(() => {
    getInfo()
    let ele = document.getElementById("t-suspend-button");
    let recordStateLocal = localStorage.getItem("recordState");
    if (ele) {
      if (recordStateLocal) {
        let recordState = JSON.parse(recordStateLocal);
        ele.style.left = recordState.actionBall.left;
        ele.style.top = recordState.actionBall.top;
      }
      ele.addEventListener(
        "touchmove",
        (e) => {
          if (e.cancelable) {
            e.preventDefault();
          }
        },
        {
          passive: false,
        }
      );
    }
  }, []);
  //当开始触摸
  const onTouchStart = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = true;
    if (ele) {
      ele.style.opacity = "1";
      oW = e.clientX - ele?.getBoundingClientRect().left;
      oH = e.clientY - ele?.getBoundingClientRect().top;
      htmlWidth = document.documentElement.clientWidth;
      htmlHeight = document.documentElement.clientHeight;
      bWidth = ele.offsetWidth;
      bHeight = ele.offsetHeight;
      oLeft = e.clientX - oW;
      oTop = e.clientY - oH;

      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
      moving = true;
    }
  };
  // 获取绑定信息
  const getInfo = async ()=>{
    const { data } = await api.getSubjectBindState(subjectCode)
    setBindInfo(data)
  }
  //当触摸结束
  const onTouchEnd = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    moving = false;

    // 左侧距离
    let oLeft1 = oLeft;
    if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
      oLeft1 = 0;
    } else {
      oLeft1 = `${htmlWidth - bWidth}px`;
    }
    oLeft = oLeft1;
    if (ele) {
      ele.style.left = oLeft;
      let recordState = {
        actionBall: {
          left: ele.style.left,
          top: ele.style.top,
        },
      };
      localStorage.setItem("recordState", JSON.stringify(recordState));
      setTimeout(() => {
        if (ele) {
          ele.style.opacity = "0.8";
        }
      }, 2000);
    }
  };

  // 当开始触摸
  const onTouchMove = (e: any) => {
    moving && onMove(e);
  };

  // 当触摸
  const onMove = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = false;

    // 左侧距离
    let oLeft1 = e.clientX - oW;
    let oTop1 = e.clientY - oH;
    if (oLeft1 < 0) {
      oLeft1 = 0;
    } else if (oLeft1 > htmlWidth - bWidth) {
      oLeft1 = htmlWidth - bWidth;
    }
    if (oTop1 < 0) {
      oTop1 = 0;
    } else if (oTop1 > htmlHeight - bHeight) {
      oTop1 = htmlHeight - bHeight;
    }
    oLeft = oLeft1;
    oTop = oTop1;
    if (ele) {
      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
    }
  };

  useEffect(() => {
    document.title = '上报提醒'
    if (!subjectCode || !bindInfo) return;
    getWxCode(subjectCode);
  }, [bindInfo]);

  // 自报提醒
  const toRemindBySms = ()=>{
    api.remindBySms({
      scaleId: urlParams?.scaleId,
    }).then((res:any)=>{
      const {code ,message} = res
      if(code === 0){
        Toast.success("发送成功！", 1);
        props.history.go(-1);
      }else{
        Toast.fail(message, 1)
      }
    })
  }
  const getWxCode = async (subjectCode: string) => {
    try {
      console.log(bindInfo)
      const doctorName = JSON.parse(sessionStorage.getItem("token") ?? "{}")?.userName;
      if (!doctorName) return;
      const result = await api.scanExamCode({
        projectCode:bindInfo?.projectCode,
        scaleId: urlParams?.scaleId,
        subjectCode
      })
      const url = result?.data+`&recordId=default&scaleName=${urlParams?.scaleName}&scaleCode=${urlParams?.scaleCode}&isScan=true`
      console.log(url)
      setCodeURL(url);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return subjectCode ? (
    <div className="report-tip--container">
      <div className="report-tip--tabs">
        <Tabs activeKey={bindType}   onChange={(key:any) => {
            console.log(key)
            setBindType(key)
          }}>
          <Tabs.Tab title="线下提醒" key="wx"></Tabs.Tab>
          <Tabs.Tab title="短信提醒" key="msg"></Tabs.Tab>
        </Tabs>
      </div>
      {bindType === "wx" && (
        <div className="report-tip--wx">
          <div className="report-tip--tips"></div>
          <div className="report-tip--code">
            <div className="border_corner border_corner_left_top"></div>
            <div className="border_corner border_corner_right_top"></div>
            <div className="border_corner border_corner_left_bottom"></div>
            <div className="border_corner border_corner_right_bottom"></div>
            {!!codeURL && <QRCodeCanvas className="report-tip--img" value={codeURL} />}
          </div>
          <div className="report-tip--remind">
            <BellOutline className="icon" />
            扫问卷码立即填写
          </div>
        </div>
      )}
      {
        bindType === "msg" && (
            <>
                <div className="card-container">
                    <div className="card-title">上报提醒</div>
                    <div className="card-content">
                      <div className="card-content-part1"><img  src={iconFile} alt=""/>{urlParams?.scaleName}</div>
                      {/* <div className="card-content-part2">应上报1次，实际上报<span style={{'color':'red'}}>0</span>次</div> */}
                    </div>
                    <div className="card-second-title">根据以下身份提醒患者上报</div>
                    <div className="doctor-info">
                      <div className="doctor-info-hospital">{bindInfo.centerName}</div>
                      <div className="doctor-info-name">{bindInfo.doctorName}</div>
                    </div>
                </div>
                <div className="btn-bottom">
                    <Button  className="btn-bottom-content" color='primary'  shape='rounded'   onClick={toRemindBySms}>发送提醒</Button>
                    {/* <div className="btn-bottom-tip">每人每日仅能提醒一次</div> */}
                </div>
           </>
        )
      }
      <div
        className="addAction"
        id="t-suspend-button"
        onTouchStart={(e) => onTouchStart(e)}
        onTouchMove={(e) => onTouchMove(e)}
        onTouchEnd={(e) => onTouchEnd(e)}
      >
        <img
          src={backBtn}
          alt="back"
          onClick={() => {
            props.history.go(-1);
          }}
        />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default withRouter(SubjectBindType);
